<template>
  <v-dialog v-model="computedIsVisible" persistent max-width="768">
    <v-card>
      <v-card-title class="headline">{{ $i18n.t(`dashboard.projects.table.attachments`) }}</v-card-title>
      <v-card-text>
        <v-row no-gutters justify="center">
          <CustomDataTable
            v-if="isFetched"
            :headers="headers"
            :items="attachments"
            entity-type="attachments"
            disable-pagination
            :has-tools="false"
          >
            <template #visible="{ item }">
              <td>
                <v-row no-gutters justify="center" align="center">
                  <v-checkbox class="pa-0 ma-0" dense hide-details v-model="item.visible" color="primary" />
                </v-row>
              </td>
            </template>
          </CustomDataTable>
          <v-progress-circular v-else color="primary" indeterminate size="25" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn color="primary" text @click="cancel" :disabled="loading">{{ $i18n.t('default.cancel') }}</v-btn>
        <v-btn color="primary" text @click="save" :loading="loading" :disabled="!isFetched">
          {{ $i18n.t('default.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {
    CustomDataTable: () => import('@/components/CustomDataTable')
  },
  props: {
    isVisible: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    projectId: {
      type: [Number, String],
      required: true
    },
    projectLink: {
      type: Object,
      required: true
    },
    success: {
      type: Function,
      default: () => {
        return;
      }
    }
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      }
    }
  },
  data: () => ({
    attachments: [],
    headers: [
      {
        sortable: false,
        text: 'visible',
        value: 'visible',
        type: 'text'
      },
      {
        text: 'pl',
        value: 'pl',
        type: 'text'
      },
      {
        text: 'en',
        value: 'en',
        type: 'text'
      },
      {
        text: 'created_at',
        value: 'created_at',
        type: 'date'
      },
      {
        text: 'created_by',
        type: 'text',
        value: 'created_by'
      }
    ],
    isFetched: false,
    loading: false
  }),
  methods: {
    cancel() {
      this.computedIsVisible = false;
    },
    getAttachments() {
      this.isFetched = false;
      const payload = {
        type: 'project',
        id: this.projectId,
        params: { with_offers_attachments: true }
      };
      this.$store.dispatch('getAttachments', payload).then(r => {
        if (r.status === 200) {
          const unique = (array, key) => {
            return [...new Map(array.map(element => [key(element), element])).values()];
          };
          const offersAttachments = r.data.files.filter(file => file.entity_type === 'offer');
          const sharedAttachments = this.projectLink.attachments;
          const attachments = offersAttachments.map(attachment => {
            return { ...attachment, visible: sharedAttachments.includes(attachment.id) ? true : false };
          });
          const attachmentUniques = unique(attachments, a => a.id);
          this.attachments = attachmentUniques.map(attachment => {
            delete attachment.entity_type;
            delete attachment.entity_id;
            return attachment;
          });
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t(`default.error`));
          this.computedIsVisible = false;
        }
        this.isFetched = true;
      });
    },
    save() {
      this.loading = true;
      const visibleAttachments = this.attachments.filter(attachment => attachment.visible);
      const visibleAttachmentsIds = visibleAttachments.map(attachment => attachment.id);

      const payload = {
        id: this.projectId,
        uuid: this.projectLink.uuid,
        attachments: visibleAttachmentsIds
      };
      this.$store
        .dispatch('editProjectLink', payload)
        .then(r => {
          if (r.status === 200) {
            this.$root.$emit('showSnackbar', this.$i18n.t(`dialog.header.editedLink`));
            this.success();
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
          }
          this.loading = false;
          this.computedIsVisible = false;
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    }
  },
  watch: {
    computedIsVisible(nV) {
      if (nV) {
        this.getAttachments();
      }
    }
  }
};
</script>